
export default {
  props: {
    text: { type: String, required: true }
  },
  render (createElement) {
    return createElement('p', {
      domProps: {
        innerHTML: this.text
      }
    })
  }
}
